module.exports = __webpack_public_path__ + "static/media/skywallet_9.c65bdd72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/skywallet_9.jpg
// module id = 1510
// module chunks = 0